import dayjs from 'dayjs';
import { useDayPicker } from 'react-day-picker';

/**
 * Custom month caption: renders  ‹  MMMM YYYY  ›  in a single row.
 * Defined outside the parent so its identity is stable across re-renders.
 */
export const MonthCaption = ({ calendarMonth, availabilityFetching }) => {
  const { goToMonth, nextMonth, previousMonth } = useDayPicker();
  return (
    <div className="udp-calendar-header">
      <button
        type="button"
        className="udp-nav-btn"
        onClick={() => previousMonth && goToMonth(previousMonth)}
        disabled={!previousMonth}
        aria-label="previous month"
      >
        ‹
      </button>
      <span className="udp-month-label">
        {dayjs(calendarMonth.date).format('MMMM YYYY')}
        {availabilityFetching && (
          <span className="udp-caption-pulse" aria-hidden="true">
            <span className="udp-caption-pulse__circle" />
            <span className="udp-caption-pulse__circle" />
            <span className="udp-caption-pulse__circle" />
          </span>
        )}
      </span>
      <button
        type="button"
        className="udp-nav-btn"
        onClick={() => nextMonth && goToMonth(nextMonth)}
        disabled={!nextMonth}
        aria-label="next month"
      >
        ›
      </button>
    </div>
  );
};

// Hide the default nav — navigation is rendered inside MonthCaption
export const HiddenNav = () => null;
